const DATE_TYPE_METADATA_KEY = Symbol("type:datetype");

export default abstract class AbstractModel {
  public inject(data: Partial<this>) {
    Object.entries(data).forEach(([k, v]) => {
      if (Reflect.hasMetadata(DATE_TYPE_METADATA_KEY, this, k)) {
        this[k] = v && new Date(v);
      } else {
        this[k] = v && parse(v);
      }
    });
    return this;
  }

  toJSON() {
    return {
      ...this,
      "@class": this.constructor.prototype["@class"],
      toJSON: undefined
    };
  }
}

let _modelRegistry = new Map<string, new () => AbstractModel>();

export function parse<T extends AbstractModel>(data: Partial<T> | Partial<T>[]) {
  if (data instanceof Array) {
    return data.map(parse);
  } else {
    if (data && typeof data === "object" && data["@class"]) {
      const ctor = _modelRegistry.get(data["@class"] as string);
      if (ctor) {
        return new ctor().inject(data);
      } else {
        console.error(`Unable to find class ${data["@class"]} in registry`, _modelRegistry);
        return data;
      }
    } else {
      return data;
    }
  }
}

export const Model = function(name: string) {
  return function<T extends AbstractModel>(constructor: new () => T) {
    _modelRegistry.set(name, constructor);
    constructor.prototype["@class"] = name;
  };
};

export const DateType = function() { return Reflect.metadata(DATE_TYPE_METADATA_KEY, true); }
